/**
 * Where to go after signing in, taken from a query string — which means taken from whoever wrote
 * the link. Only a path on this site is honoured: the router treats an absolute URL as a real
 * navigation, so `/login?returnUrl=https://elsewhere.example` would otherwise hand a freshly
 * signed-in visitor to a page made to look like this one.
 */
export function safeReturnUrl(raw: string | null | undefined, fallback = '/dashboard'): string {
  if (!raw || !raw.startsWith('/')) {
    return fallback;
  }

  // "//host" is protocol-relative and "/\host" is read the same way by browsers.
  if (raw.startsWith('//') || raw.startsWith('/\\')) {
    return fallback;
  }

  return raw;
}
